/** The "Done / To do" status chip on each part of a step. */
export function Pill({
  ok,
  okText = "Done",
  noText = "To do",
}: {
  ok: boolean;
  okText?: string;
  noText?: string;
}) {
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-[var(--radius-chip)] px-2.5 py-0.5 text-[11.5px] font-bold ${
        ok ? "bg-positive-tint text-positive" : "bg-surface-high text-text-muted"
      }`}
    >
      {ok ? okText : noText}
    </span>
  );
}
